export const energyManagementKeyLabel = {
  Q1: {
    key: 'energy_q1',
    lab: 'Gross floor area with complete energy consumption data coverage'
  },
  Q2: {
    key: 'energy_q2',
    lab: 'The total portfolio gross floor area for which energy is used.'
  },
  Q3: {key: 'energy_q3', lab: 'Percentage by floor area'},
  Q4: {
    key: 'energy_q4',
    lab: ' Total energy consumed by portfolio area with data coverage',
    tooltip: `The scope of disclosure includes all property area in the entity’s portfolio for 
      which energy consumption data coverage is available, regardless of whether the Tenant Space
       or Base Building consumes the energy (including outdoor, exterior and parking areas)
       and which party pays for energy expenses`
  },
  Q5: {key: 'energy_q5', lab: 'Purchased grid electricity consumption'},
  Q6: {key: 'energy_q6', lab: 'Total energy consumption'},
  Q7: {key: 'energy_q7', lab: 'Percentage of grid electricity'},
  Q8: {key: 'energy_q8', lab: 'Renewable energy consumed'},
  Q9: {key: 'energy_q9', lab: 'Total energy consumed'},
  Q10: {key: 'energy_q10', lab: 'Percentage of renewable'},
  Q11: {key: 'energy_q11', lab: 'Purchased grid electricity consumption'},
  Q12: {key: 'energy_q12', lab: 'Total energy consumption'},
  Q13: {key: 'energy_q13', lab: 'Percentage of grid electricity'},
  Q14: {
    key: 'energy_q14',
    lab: 'Portfolio gross floor area that has an energy rating'
  },
  Q15: {key: 'energy_q15', lab: 'Total portfolio gross floor area'},
  Q16: {key: 'energy_q16', lab: 'Percentage of Portfolio gross'},
  Q17: {
    key: 'energy_q17',
    lab: 'Portfolio gross floor area certified to ENERGY STAR® in the US '
  },
  Q18: {
    key: 'energy_q18',
    lab: 'The total portfolio gross floor area in the US.'
  },
  Q19: {key: 'energy_q19', lab: 'Percentage of Portfolio gross'},
  Q20: {
    key: 'energy_q20',
    lab: `Description of how building energy management considerations are integrated 
    into property investment analysis and operational strategy`
  }
};

export const energyManagementHeading = {
  HEADING_1:
    '1) Total energy consumed by portfolio area with data coverage, by property sector',
  HEADING_2: '2) Percentage grid electricity, by property sector',
  HEADING_3: '3) Percentage renewable, by property sector',
  HEADING_4:
    '1) Percentage of eligible portfolio that (1) has an energy rating , by property sector',
  HEADING_5:
    '2) Percentage of eligible portfolio that (2) is certified to ENERGY STAR, by property sector'
};

export const waterManagerHeading = {
  HEADING_1:
    '1) Water withdrawal data coverage as a percentage of (1) total floor area, by property sector',
  HEADING_2: `2) Water withdrawal data coverage as a (2) percentage of floor area in regions with High or Extremely
     High Baseline Water Stress, by property sector`,
  HEADING_3:
    '1) Total water withdrawn by portfolio area with data coverage, by property sector',
  HEADING_4:
    '2) Percentage in regions with High or Extremely High Baseline Water Stress, by property sector',
  HEADING_5:
    'Like-for-like percentage change in water withdrawn for portfolio area with data coverage, by property sector'
};

export const waterManagerKeyLabel = {
  Q1: {
    key: 'water_q1',
    lab: 'The portfolio gross floor area with complete water withdrawal data coverage'
  },
  Q2: {
    key: 'water_q2',
    lab: 'Total portfolio gross floor area for which water is used.'
  },
  Q3: {key: 'water_q3', lab: 'Percentage by floor area'},
  Q4: {
    key: 'water_q4',
    lab: `The portfolio gross floor area located in regions classified as High or Extremely High Baseline
     Water Stress and that have complete water withdrawal data coverage`
  },
  Q5: {
    key: 'water_q5',
    lab: `Total portfolio gross floor area for which water is used in regions 
    with High or Extremely High Baseline Water Stress`
  },
  Q6: {key: 'water_q6', lab: 'Percentage by floor area'},
  Q7: {
    key: 'water_q7',
    lab: 'All property area in the entity’s portfolio for which water withdrawal data coverage is available',
    tooltip: `The scope of disclosure includes all property area in the entity’s 
    portfolio for which water withdrawal data coverage is available, regardless 
    of whether water is consumed by the Tenant Space or Base Building 
    (including outdoor, exterior and parking areas) or which party pays for water expenses.`
  },
  Q8: {
    key: 'water_q8',
    lab: 'Amount of water withdrawn (by volume) in regions with High or Extremely High Baseline Water Stress'
  },
  Q9: {key: 'water_q9', lab: 'Total amount of water withdrawn (by volume).'},
  Q10: {key: 'water_q10', lab: 'Percentage by floor area'},
  Q11: {
    key: 'water_q11',
    lab: 'Water withdrawn (by volume) in the reporting period.'
  },
  Q12: {
    key: 'water_q12',
    lab: 'Water withdrawn (by volume) in the immediately prior reporting period '
  },
  Q13: {key: 'water_q13', lab: 'Percentage by floor area'},
  Q14: {
    key: 'water_q14',
    lab: 'Description of water management risks and discussion of strategies and practices to mitigate those risks',
    tooltip: `1.1.1 Environmental constraints—such as operating in water-stressed regions, drought, concerns of aquatic 
    impingement or entrainment, interannual or seasonal variability, and risks from the impact of climate change 

    1.1.2 Regulatory and financial constraints—such as volatility in water costs, stakeholder perceptions and concerns 
    related to water withdrawals (for example, those from local communities, non-governmental organisations and 
        regulatory agencies), direct competition with and impact from the actions of other users 
    (for example, commercial and municipal users), restrictions to withdrawals because of regulations, and 
    constraints on the entity’s ability to obtain and retain water rights or permits`
  }
};

export const managementTenantHeading = {
  HEADING_1: `1) Percentage of new leases that contain a cost recovery clause for resource efficiencyrelated 
  capital improvements by property sector`,
  HEADING_2: '2) Associated leased floor area, by property sector',
  HEADING_3: `1) Percentage of tenants that are separately metered or submetered for
     (1) grid electricity consumption by property sector`,
  HEADING_4:
    '2) Percentage of tenants that are separately metered or submetered for (2) water withdrawals, by property sector'
};

export const managementTenantKeyLabel = {
  Q1: {
    key: 'tenant_q1',
    lab: `The portfolio newly leased floor area associated with leases that 
    contain a cost recovery clause for resource efficiency-related capital improvements`
  },
  Q2: {
    key: 'tenant_q2',
    lab: 'Total portfolio newly leased floor area.'
  },
  Q3: {key: 'tenant_q3', lab: 'Percentage by floor area'},
  Q4: {
    key: 'tenant_q4',
    lab: 'Leased floor area',
    tooltip: `The entity shall disclose the leased floor area, in square metres, 
      associated with new leases that contain a cost recovery clause for resource 
      efficiency-related capital improvements`
  },
  Q5: {
    key: 'tenant_q5',
    lab: `The leasable floor area leased to tenants that are separately metered or
     submetered for the electricity consumption resulting from their exclusive consumption`
  },
  Q6: {key: 'tenant_q6', lab: 'The total portfolio leasable floor area.'},
  Q7: {
    key: 'tenant_q7',
    lab: 'Percentage by floor area'
  },
  Q8: {
    key: 'tenant_q8',
    lab: `The leasable floor area leased to tenants that are separately metered or 
    submetered for the water use resulting from their exclusive withdrawals`
  },
  Q9: {key: 'tenant_q9', lab: 'The total portfolio leasable floor area.'},
  Q10: {key: 'tenant_q10', lab: 'Percentage by floor area'},
  Q11: {
    key: 'tenant_q11',
    lab: 'Discussion of approach to measuring, incentivising and improving sustainability impacts of tenants',
    tooltip: `For the purposes of this disclosure, the scope of sustainability topics includes energy management,
       water management and the impacts of properties on tenant health, including indoor environmental quality.`
  }
};

export const climateChangeHeading = {
  HEADING_1:
    'Area of properties located in 100-year flood zones, by property sector'
};

export const climateChangeKeyLabel = {
  Q1: {
    key: 'CC_q1',
    lab: 'Total Area of properties located in 100-year flood zones, by property sector',
    tooltip:
      '100-year flood zones are defined as land areas subject to a 1% or greater chance of flooding in any given year'
  },
  Q2: {
    key: 'CC_q2',
    lab: `Description of climate change risk exposure analysis,
     degree of systematic portfolio exposure, and strategies for mitigating risks`,
    tooltip: `Risks and opportunities may include availability of water, extreme weather 
      events, evolving regulation and legislation, impacts on regional infrastructure, 
      impacts on tenant demand, and impacts on local economies and populations, 
      regardless of the impact of physical risks presented to the entity’s portfolio`
  }
};
